import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ProcessingOrders } from 'src/app/models/supplier-portal/supplier/supplierOrdersProcessing.models';
import { OrderHelperService } from 'src/app/services/portal-supplier/order-helper.service';

@Component({
  selector: 'app-check-order-product',
  standalone: false,
  templateUrl: './check-order-product.component.html',
  styleUrls: ['./check-order-product.component.scss'],
})
export class CheckOrderProductComponent implements OnInit {
  @Input() public productToWorkOn: ProcessingOrders.IProductInOrder | null =
    null;
  @Input() public newBatchToUpload: Partial<ProcessingOrders.IProductBatch> = {
    documents: [],
  };
  @Output()
  public readonly newBatchToUploadChange = new EventEmitter<
    Partial<ProcessingOrders.IProductBatch>
  >();

  @Output()
  public readonly disableButton = new EventEmitter<Partial<boolean>>();

  public orderService = inject(OrderHelperService);

  ngOnInit() {
    this.newBatchToUpload.qta =
      this.newBatchToUpload.quantity ?? this.getMaximum;
    this.emitValidity();
    this.newBatchToUploadChange.emit(this.newBatchToUpload);
  }

  public updateManualBatch(value: string): void {
    this.emitBatchUpdate({ manual_batch: value });
  }

  public updateQuantity(value: string): void {
    const parsed = this.parseNumber(value);
    this.emitBatchUpdate({ qta: Math.max(0, parsed ?? 0) });
  }

  private emitBatchUpdate(
    patch: Partial<ProcessingOrders.IProductBatch>,
  ): void {
    this.newBatchToUpload = {
      certification_id: this.productToWorkOn?.supplier_certificate_product_id,
      supplier_certificate_batch_id:
        this.newBatchToUpload?.supplier_certificate_batch_id ?? 0,
      certification_batch_id:
        this.newBatchToUpload?.supplier_certificate_batch_id ?? 0,
      documents: this.newBatchToUpload.documents ?? [],
      ...this.newBatchToUpload,
      ...patch,
    };

    this.emitValidity();
    this.newBatchToUploadChange.emit(this.newBatchToUpload);
  }

  private emitValidity(): void {
    const invalid =
      !this.newBatchToUpload.manual_batch ||
      !this.newBatchToUpload.qta ||
      this.newBatchToUpload.qta <= 0;

    this.disableButton.emit(invalid);
  }

  private parseNumber(value: string): number | undefined {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return undefined;
    }

    const parsedValue = Number(trimmedValue);

    return Number.isNaN(parsedValue) ? undefined : parsedValue;
  }

  get getMaximum() {
    return this.orderService?.getBatchMaximumQty ?? this.productToWorkOn?.quantity ?? 0;
  }

  get getMinimum() {
    return 1;
  }
}
